import { Routes } from "@angular/router";

import { blockDaysManagementRoutes, blockDaysRoutes } from "./block-days";

import { localReservationRoute, myTicketsListRoute, reservationDetailsRoute } from "src/app/features/my-tickets";
import { soldProductsRoutes } from "./products";

const myReservationsBaseRoute = myTicketsListRoute;

export const reservationsRoutes: Routes = [
  {
    path: "",
    title: "TICKETS.RESERVATIONS",
    data: {
      tabs: [
        {
          key: "services",
          title: "BLOCK_DAYS.ALL",
          routerLink: "/admin/reservations",
        },
        {
          key: "block-days",
          title: "BLOCK_DAYS.TITLE",
          routerLink: "block-days",
        },
        {
          key: "products",
          title: "PRODUCTS.TITLE",
          routerLink: "sold-products",
        },
      ],
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      myReservationsBaseRoute,
      {
        path: "block-days",
        children: blockDaysRoutes,
      },
      {
        path: "sold-products",
        children: soldProductsRoutes,
      },
    ],
  },
  {
    path: "view",
    // The pending route first: it and `:reservationNumber` share a segment, and Angular takes the
    // first match. Named rather than indexed — see `my-tickets.routes.ts`.
    children: [localReservationRoute, reservationDetailsRoute],
  },
  {
    path: "block-days",
    children: blockDaysManagementRoutes,
  },
];
